import { Button } from "@qastanfit/qastan-ui"
import styles from "../../../styles/pages/Management.module.scss";
import alert_red from "../../../assets/icons/alert_red.svg";
import { useState } from "react";
import { getAllUsers, handleDeleteUser } from "../../../functions/fetch/user";
import { useAppDispatch, useAppSelector } from "../../../hooks/redux";
import { setNotification, setUsers } from "../../../redux/actions";
import * as crypto from 'crypto-js';

type Props = {
    onClose: (value:boolean) => void;
    user: User | null;
}

const DeleteUser : React.FunctionComponent<Props> = ({onClose, user}) => {
    const dispatch = useAppDispatch()
    const userdata = useAppSelector(state => state.userdata);
    const users:Users = useAppSelector(state => state.users)

    const [isLoading, setisLoading] = useState<Boolean>(false);

    const deleteUser = async () => {

        if(user?.apiuserid){
            setisLoading(true);
            const d = await handleDeleteUser(user.apiuserid, userdata)
            setisLoading(false);
            if(d.errorcode === 0){
                onClose(true);
                dispatch(setNotification({type:"success", title:"Succes", message:"Gebruik verwijderen voltooid"}))

                //Remove manually from Redux state (performance speed)
                const index = users.findIndex(v => v.apiuserid === user.apiuserid)
                if(index > -1){
                    let tmp = [...users];
                    tmp.splice(index, 1)
                    dispatch(setUsers(tmp))
                }

                //Fetch again (updated list)
                let u = await getAllUsers(userdata);
                if(u.errorcode === 0){
                    //Save data in localStorage as cache
                    const stringified_users = JSON.stringify(u.object);
                    const encrypted_users = crypto.AES.encrypt(stringified_users, process.env.REACT_APP_SECRET || "");
                    localStorage.setItem("users", encrypted_users.toString());

                    //Save data in Redux state
                    dispatch(setUsers(u.object.users))
                }
            }
            else {
                console.error(d);
                dispatch(setNotification({type:"error", title:"Mislukt", message:"Gebruik verwijderen mislukt"}))
            }
        }
        else {
            setisLoading(false);
            console.error("No user id found")
            dispatch(setNotification({type:"error", title:"Mislukt", message:"Gebruik verwijderen mislukt"}))
        }
    }

    return (
        <div className={styles.alert}>
            <div className={styles.icon}><img src={alert_red} alt="alert"/></div>
            <p className={styles.title}>Gebruiker verwijderen</p>
            <p className={styles.description}>Bent u zeker deze gebruiker te verwijderen: <span className={styles.columnname}>{user?.firstname} {user?.lastname}</span>?</p>
            <div className={styles.actions}>
                <Button onClick={()=>{onClose(false)}} kind="plain">Annuleren</Button>
                <Button isLoading={isLoading} onClick={()=>{deleteUser()}}>Verwijderen</Button>
            </div>
        </div>
    )
}

export default DeleteUser;